import moduleAbilities from "@/composables/moduleAbilities";
import abilities from "@/composables/abilities";

export default {
    /*
    |--------------------------------------------------------------------------
    | projects Routes
    |--------------------------------------------------------------------------|
    */

    path: 'qvct',
    name: 'qvct',
    children: [
        {
            path: 'surveys',
            component: () => import('@/Modules/Qvct/views/Survey/Index.vue'),
            name: 'qvct-survey-index',
            meta: { requiresAccess: [moduleAbilities.QVCT_SURVEY]},
        },
        {
            path: 'surveys/create',
            component: () => import('@/Modules/Qvct/views/Survey/Create.vue'),
            name: 'qvct-survey-create',
            meta: { requiresAccess: [moduleAbilities.QVCT_SURVEY]},
        },
        {
            path: 'surveys/:id/view',
            component: () => import('@/Modules/Qvct/views/Survey/View.vue'),
            name: 'qvct-survey-view',
            meta: { requiresAccess: [moduleAbilities.QVCT_SURVEY]},
        },
        {
            name: "qvct-settings",
            path: "qvct-settings",
            component: () => import('@/Modules/Qvct/views/Settings/Layouts/BaseQvctSurveySetting.vue'),
            children: [
                {
                    name: "qvct-category-settings",
                    path: "categories",
                    component: () => import('@/Modules/Qvct/views/Settings/Categories/index.vue'),
                    meta: { requiresPermission:  abilities.CAN_QVCT_SURVEY_CATEGORY_VIEW , requiresAccess: [moduleAbilities.QVCT_SURVEY]}
                },
                {
                    name: "qvct-populations-settings",
                    path: "populations",
                    component: () => import('@/Modules/Qvct/views/Settings/Populations/index.vue'),
                    meta: { requiresPermission:  abilities.CAN_QVCT_SURVEY_CATEGORY_VIEW , requiresAccess: [moduleAbilities.QVCT_SURVEY]}
                },
                {
                    name: "qvct-answer-type-settings",
                    path: "answerTypes",
                    component: () => import('@/Modules/Qvct/views/Settings/AnswerType/index.vue'),
                    meta: { requiresPermission:  abilities.CAN_QVCT_SURVEY_CATEGORY_VIEW , requiresAccess: [moduleAbilities.QVCT_SURVEY]}
                },
                {
                    name: "qvct-answer-choice-settings",
                    path: "answerChoice",
                    component: () => import('@/Modules/Qvct/views/Settings/AnswerChoice/index.vue'),
                    meta: { requiresPermission:  abilities.CAN_QVCT_SURVEY_CATEGORY_VIEW , requiresAccess: [moduleAbilities.QVCT_SURVEY]}
                },
                {
                    name: "qvct-answer-mark-settings",
                    path: "answerMark",
                    component: () => import('@/Modules/Qvct/views/Settings/AnswerMark/index.vue'),
                    meta: { requiresPermission:  abilities.CAN_QVCT_SURVEY_CATEGORY_VIEW , requiresAccess: [moduleAbilities.QVCT_SURVEY]}
                }
            ]
        },
    ]

}

